import {
  deleteWareHouse,
  getAllWareHouses,
} from "../../../actions/wareHouseActions";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Warehouses from "../../../containers/Warehouses/Warehouses/Warehouses";
import { Translate } from "../../../../language";
import { Link } from "react-router-dom";

export const WareHouseList = ({ history }) => {
  const dispatch = useDispatch();
  const { wareHouseList } = useSelector((state) => state.WareHouse);
  useEffect(() => {
    dispatch(getAllWareHouses());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <Warehouses listWarehouses={wareHouseList} />
    </div>
  );
};
